import axiosIns from '@/libs/axios'

export default {
  namespaced: true,
  state: {
    permitTypes: [],
    permitTypesCount: 0,
    permitType: {},
    permitTypeSave: {
      message: null,
      status: null,
      id: null,
    },
  },
  getters: {
    getPermitTypes(state) {
      return state.permitTypes
    },
    getPermitTypesCount(state) {
      return state.permitTypesCount
    },
    getPermitType(state) {
      return state.permitType
    },
    getPermitTypeSaveStatus(state) {
      return state.permitTypeSave
    },
  },
  mutations: {
    PERMIT_TYPES_LIST(state, data) {
      state.permitTypes = data
    },
    PERMIT_TYPE_VIEW(state, data) {
      state.permitType = data
    },
    PERMIT_TYPES_COUNT(state, data) {
      state.permitTypesCount = data
    },
    PERMIT_TYPE_SAVE(state, data) {
      state.permitTypeSave = data
    },
  },
  actions: {
    permitTypesList({ commit }, params) {
      const data = JSON.stringify(params)
      axiosIns
        .post('/hrDefines/permit_types', data)
        .then(response => {
          commit('PERMIT_TYPES_LIST', response.data.data)
          commit('PERMIT_TYPES_COUNT', response.data.count)
        })
        .catch(error => console.error(error))
    },
    permitTypeView({ commit }, id) {
      const data = JSON.stringify({
        where: {
          'permit_types.id': id,
        },
        array: false,
      })
      axiosIns
        .post('/hrDefines/permit_types', data)
        .then(response => {
          commit('PERMIT_TYPE_VIEW', response.data.data)
        })
        .catch(error => console.error(error))
    },
    permitTypeSave({ commit }, postData) {
      const data = JSON.stringify(postData)
      axiosIns
        .post('/hrDefines/permit_types/saveData', data)
        .then(response => {
          commit('PERMIT_TYPE_SAVE', response.data)
        })
        .catch(error => console.error(error))
    },
  },
}
